import React, { ReactElement, useEffect, useRef } from 'react';
import type { Route } from 'next';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { RootState } from 'redux/store';
import { reCaptcha } from 'utils/helpers/reCaptcha';
import RootLayout from 'layouts/RootLayout';
import Breadcrumbs from 'components/Breadcrumbs';
import { Settings } from 'sections/Company/ContactUs/types';
import { Contact } from 'sections/Company/ContactUs/components/Contact';
import styles from 'pages/partners/erp-enquiry/ErpEnquiry.module.scss';

const cn = classNames.bind(styles);

export default function ErpEnquiry() {
  const [{ user }] = useCookies(['user']);
  // const root = useRef<HTMLDivElement>(null);
  const { logged } = useSelector((state: RootState) => state.userData);

  let contact: Settings = {
    subject: ['IT Service', 'Logistics Service', 'Digital Freight Alliance', 'Other'],
    platform: 'Channel partner program',
    addressVisible: true,
  };

  if (logged) {
    contact = {
      ...contact,
      ...{
        name: user?.name,
        email: user?.email,
        phone: user?.phone
      },
    }
  };

  useEffect(() => {
    reCaptcha();
  }, []);

  return (
    <div className={cn('erp-enquiry')}>
      <div className={cn('container')}>
        <Breadcrumbs mTop={64} mode="dark" links={[{ title: 'ERP Enquiry', href: '' as Route }]} />

        <div className={cn('erp-enquiry__contact-container')}>
          <Contact
            key={logged}
            contact={contact}
            page='erp'
          />
        </div>
      </div>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'For Business Enquiry-Contact Us | Digital Freight Alliance',
      description: 'Know about Contact Address of Digital Freight Alliance.',
      path: '/partners/erp-enquiry',
    },
  };
};

ErpEnquiry.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
